import {Routes} from '@angular/router';
import {IndexPage} from "./pages/index/index.page";
import {MixingPage} from "./pages/mixing/mixing.page";
import {PressurePage} from "./pages/pressure/pressure.page";
import {LegalPage} from "./pages/legal/legal.page";

export const routes: Routes = [
  {path: '', component: IndexPage},
  {path: $localize`:@@route_pressure:pressure`, component: PressurePage},
  {path: $localize`:@@route_mixing:mixing`, component: MixingPage},
  {path: $localize`:@@route_legal:legal`, component: LegalPage},
]
